module.exports = __webpack_public_path__ + "img/fordays-transparent.b528fcea.png";